import {useDispatch, useSelector} from "react-redux";
import { useT } from '../../../../../../helpers/i18n';
import {ReactComponentElement, useEffect, useRef, useState} from "react";
import * as React from "react";
import {
    fetchPropertyBedroomById,
    fetchPropertyBedrooms,
    fetchPropertyPool,
    fetchPropertySpace,
    fetchPropertySpaces
} from "../../../../../../redux/actions";
import {useInViewport} from "react-in-viewport";
import Skeleton from "react-loading-skeleton";
import FiltersModal from "../../../../properties/partials/FiltersModal";
import RightModal from "../../../../properties/partials/RightModal";
import Button from "@mui/material/Button";
import SwipperWrapper from "../../../../properties/partials/SwipperWrapper";
import SimpleContent from "../../../../properties/partials/SImpleContent";
import FeaturesList from "../../../../properties/partials/FeaturesList";
import AttributesList from "../../../../properties/partials/AttributesList";
import BedroomsContentWrapper from "../../../../properties/partials/BedroomsContentWrapper";
import ContentWrapper from "../../../../properties/partials/ContentWrapper";
import {AnyComponent} from "styled-components/native/dist/types";
import {SwiperSlide} from "swiper/react";
import Checkers from "../../../../../../helpers/class/Checkers";
import BedsArrangement from "../../../../properties/partials/BedsArrangement";

export default function ExtendedCarouselSpaces ( props ){
  const t = useT();

    const config = {disconnectOnLeave: false};

    const options = {};

    const myRef = useRef();

    const {
        inViewport
    } = useInViewport(
        myRef,
        options,
        config,
        props
    );

    const dispatch = useDispatch()

    const propertyId = useSelector( state => state['propertiesParams']['property_id']);

    useEffect( () => {
        dispatch<any>( fetchPropertySpaces(propertyId) )
    }, [inViewport])

    const componentLoading = useSelector( state => state['singlePropertyData']['loading'])

    const propertyPools = useSelector( state => state['singlePropertyData']['pools'])

    const propertySpaces = useSelector( state => state['singlePropertyData']['spaces'])

    const propertyBedrooms = useSelector( state => state['singlePropertyData']['bedrooms'])

    const [ modalState, setModalState ] = useState( "close" );

    const modalBedroomsData = useSelector( state => state['singlePropertyData']['modalBedrooms'])

    const modalData = useSelector( state => state['singlePropertyData']['modal'])

    const modalMedia = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['media'] : null )

    const modalDataExtendend = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data'] : null )

    const modalContent = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['description'] : null )

    const modalContentExtra = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['space_details'] : '' )

    const modalFeaturesList = useSelector( state => state['singlePropertyData']['modal']['valid'] ? state['singlePropertyData']['modal']['data']['features'] : null )

    const pageId = useSelector(state => state['propertiesParams']['page_id']);

    const handleShow = ( type, area_id ) => {
        if (type=='poolModal' ) {
            dispatch<any>(fetchPropertyPool(pageId, propertyId, area_id))
        } else if ( type=='spaceModal' ) {
            dispatch<any>(fetchPropertySpace(pageId, propertyId, area_id))
        } else if ( type=='bedroomModal' ) {
            dispatch<any>(fetchPropertyBedroomById(pageId, propertyId, area_id))
        }

        setModalState( type+(area_id!=null ? area_id : '') );
    }

    const handleHide = () => {
        setModalState( "close" );
    }

    const propertyBedroom = useSelector( state => state['singlePropertyData']['modalSingleBedroom'])

    const propertyBedroomData = propertyBedroom.hasOwnProperty('data') ? (Checkers.isValidArray(propertyBedroom.data) ? propertyBedroom.data[0] : propertyBedroom.data) : null


    const spacesComponent : Array<ReactComponentElement<AnyComponent>> = []

    if (propertyPools != null && propertyPools.length > 0) {
        propertyPools.map((pool) => {
            if (pool.media == undefined || pool.media == null) {
                return
            }

            const space =
                <>
                    <div className="text-center bg-success hover-push demo-story-block"
                         onClick={() => handleShow('poolModal', pool.pool_id)}
                    >
                        <div className={"hover-backdrop"}
                             style={{backgroundImage: 'url(' + (pool.media != undefined && pool.media != null ? pool.media.image_square_thumb : "") + ')'}}
                        />
                        <div className="hover-caption bottom-left bottom-right p-b-20">
                            <h4 className="fs-16 text-white m-b-0">
                                {pool.pool_title}
                            </h4>
                        </div>
                    </div>
                    {
                        <RightModal
                            key={100}
                            modalName={'poolModal' + pool.pool_id}
                            className="slide_right"
                            Title={pool.pool_title}
                            modalSize="lg"
                            loaderStatus={!modalData.valid}
                            closeModal={() => {
                                handleHide()
                            }}
                            show={modalState === 'poolModal' + pool.pool_id}
                            BodyRender={<ContentWrapper ContentRender={
                                <>
                                    <SwipperWrapper key="pool-images-swiper" images={modalMedia} enableFancyBox={true}
                                                    enableAlbumRightModal={false}/>
                                    <SimpleContent content={modalContent}/>
                                    <AttributesList data={modalDataExtendend}/>
                                    <FeaturesList featureList={modalFeaturesList}/>
                                </>
                            }/>}
                        />
                    }
                </>

            spacesComponent.push(<SwiperSlide>{space}</SwiperSlide>)
        })
    }

    if (propertySpaces !=null && propertySpaces != undefined && propertySpaces.length > 0) {

        propertySpaces.map((space) => {
            if (space.media == undefined || space.media == null) {
                return
            }

            const spaceItem =
                <>
                    <div className="text-center bg-success hover-push demo-story-block"
                         onClick={() => handleShow( 'spaceModal', space.space_id )}
                    >
                        <div className={"hover-backdrop"}
                             style={{ backgroundImage: 'url('+(space.media!=undefined && space.media!=null ? space.media.image_square_thumb : "")+')' }}
                        />
                        <div className="hover-caption bottom-left bottom-right p-b-20">
                            <h4 className="fs-16 text-white m-b-0">
                                {space.space_title}
                            </h4>
                        </div>
                    </div>
                    {
                        <RightModal
                            key={100}
                            modalName={'spaceModal'+space.space_id}
                            className="slide_right"
                            Title={space.space_title}
                            modalSize="lg"
                            loaderStatus={!modalData.valid}
                            closeModal={() => {
                                handleHide()
                            }}
                            show={modalState === 'spaceModal'+space.space_id}
                            BodyRender={ <ContentWrapper ContentRender={
                                <>
                                    <SwipperWrapper key={'space-images-swiper'} images={modalMedia} enableFancyBox={true} enableAlbumRightModal={false} />
                                    <SimpleContent content={modalContent} extraContent={modalContentExtra}/>
                                    <AttributesList data={modalDataExtendend}/>
                                    <FeaturesList featureList={modalFeaturesList}/>
                                </>
                            } /> }
                        />
                    }
                </>


            spacesComponent.push(<SwiperSlide>{spaceItem}</SwiperSlide>)
        })
    }

    const bedroomsComponent : Array<ReactComponentElement<AnyComponent>> = []

    if (propertyBedrooms !=null && propertyBedrooms != undefined && propertyBedrooms.length > 0) {
        propertyBedrooms.map((bedroom, i) => {
            if (bedroom.media == undefined || bedroom.media == null) {
                return
            }

            const bedroomItem =
                <>
                    <div className="text-center bg-success hover-push demo-story-block"
                         onClick={() => handleShow( 'bedroomModal', bedroom.bedroom_id )}
                    >
                        <div className={"hover-backdrop"}
                             style={{backgroundImage: 'url(' + (bedroom.media != undefined && bedroom.media != null ? bedroom.media.image_square_thumb : "") + ')'}}
                        />
                        <div
                            className="hover-caption bottom-left bottom-right p-b-20">
                            <h4 className="fs-16 text-white m-b-0">
                                {bedroom.bedroom_title}
                            </h4>
                        </div>
                    </div>
                    {
                        <RightModal
                            key={100}
                            modalName={'bedroomModal'+bedroom.bedroom_id}
                            className="slide_right"
                            Title={bedroom.bedroom_title}
                            modalSize="lg"
                            loaderStatus={!propertyBedroom.valid}
                            closeModal={() => {
                                handleHide()
                            }}
                            show={modalState === 'bedroomModal'+bedroom.bedroom_id}
                            BodyRender={ <ContentWrapper ContentRender={
                                <>
                                    {
                                        propertyBedroomData!=null ?
                                            <>
                                                {
                                                    propertyBedroomData.hasOwnProperty('media') && Checkers.isValidArray(propertyBedroomData.media) ?
                                                        <SwipperWrapper key="bedroom-images-swiper" images={propertyBedroomData.media} enableFancyBox={true} enableAlbumRightModal={false} />
                                                        :
                                                        <></>
                                                }
                                                <SimpleContent content={propertyBedroomData.description} />
                                                <AttributesList data={propertyBedroomData} />
                                                <BedsArrangement data={propertyBedroomData} />
                                                <FeaturesList featureList={propertyBedroomData.features}/>
                                            </>
                                            :
                                            <>
                                            </>
                                    }
                                </>
                            } /> }
                        />
                    }
                </>

            bedroomsComponent.push(<SwiperSlide>{bedroomItem}</SwiperSlide>)
        })
    }

    return (
        componentLoading ?
            <>
                <div ref={myRef}>
                    <Skeleton height={30} className="col-8 col-sm-5 col-md-3 b-rad-md mb-1"/>
                    <Skeleton height={42} className="col-8 col-sm-6 col-md-4 b-rad-md mb-2"/>
                    <Skeleton height={70} className="col-12 col-sm-10 col-md-8 b-rad-md mb-1"/>
                    <Skeleton height={150} className="col-12 b-rad-lg"/>
                </div>
            </>
            :
            <>
                {
                    propertyPools != null || propertySpaces !=null || propertyBedrooms !=null ?
                        <>
                            <div className="col-12">
                                <p className="block-title m-t-40 hint-text no-margin">{t('property.layout')}</p>
                                <h2 className="m-t-5">{t('property.bedrooms')}</h2>
                                <div id="pro_detail_spaces" className="p-b-65">
                                    <div className="row padding-15">
                                        {
                                            <SwipperWrapper
                                                key={"bedrooms-slider"}
                                                imageSlider={false}
                                                htmlSlides={bedroomsComponent}
                                                paginationBulletsEnabled={false}
                                                slidesPerView={3}
                                                slidesPerViewLg={3}
                                                slidesPerViewMd={3}
                                                slidesPerViewSm={2}
                                                slidesPerViewXs={1.4}
                                                spaceBetween={20}
                                                enableLoop={false}
                                                galleryHeight={'auto'}
                                                wrapperClassName={'d-navigation p-0 '}
                                                enableFancyBox={false}
                                                centeredSlides={false}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <h2 className="m-t-5">{t('property.spaces')}</h2>
                                <div id="pro_detail_spaces" className="p-b-65">
                                    <div className="row padding-15">
                                        {
                                            <SwipperWrapper
                                                key={"spaces-slider"}
                                                imageSlider={false}
                                                htmlSlides={spacesComponent}
                                                paginationBulletsEnabled={false}
                                                slidesPerView={3}
                                                slidesPerViewLg={3}
                                                slidesPerViewMd={3}
                                                slidesPerViewSm={2}
                                                slidesPerViewXs={1.4}
                                                spaceBetween={20}
                                                enableLoop={false}
                                                galleryHeight={'auto'}
                                                wrapperClassName={'d-navigation p-0 '}
                                                enableFancyBox={false}
                                                centeredSlides={false}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                        : <></>
                }
            </>
    )
}